module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1041-e9bdc38e2eb7c81a57c4305542034b68.png";